import React, { useState } from "react"
import Axios from "./axios"

import Downshift from "downshift"
import * as classNames from "./AutocompleteCompanyField.module.scss"

const baseEndpoint = process.env.GATSBY_NEST_BASE_URL + "/company-search"
const DownshiftLazy = React.lazy(() => import("downshift"))

export default ({ value, onChange, formRegister }) => {
  const [isListVisible, setListVisible] = useState(false)

  const handleInputFocus = () => {
    setListVisible(true)
  }

  return (
    // <Suspense fallback={<div>Chargement...</div>}>
      <Downshift
        //initialInputValue={value?.companyName}
        onChange={onChange}
        // itemToString={(item) => (item ? JSON.stringify(item) : "")}
      >
        {({
          getInputProps,
          getItemProps,
          getLabelProps,
          getMenuProps,
          isOpen,
          inputValue,
          highlightedIndex,
          selectedItem,
          clearSelection,
          openMenu,
        }) => (
          <div className={classNames.container + " MeetingContactformContainer"}>
            <label
              {...getLabelProps()}
              className="label"
              htmlFor="siret"
            >
              Société<sup>*</sup>
            </label>
            {selectedItem ? (
              selectedItem.isNew ? (
                <>
                  <div
                    className={classNames.inputLike}
                    style={{ marginBottom: "16px" }}
                  >
                    Je suis en création d'entreprise, ou je ne trouve pas mon
                    entreprise
                    <span
                      onClick={() => {
                        clearSelection()
                      }}
                    >
                    </span>
                  </div>

                  <label
                    className="label"
                    htmlFor="raison-sociale"
                  >
                    Raison sociale
                  </label>
                  <input
                    className="input"
                    id="raison-sociale"
                    name="raison-sociale"
                    placeholder="Nom de votre entreprise"
                    autoComplete="off"
                    {...formRegister("raison-sociale")}
                  />
                </>
              ) : (
                <div
                  className={classNames.inputLike + " flex-direction-column"}
                >
                  <div style={{ fontWeight: "bolder" }}>
                    {selectedItem.companyName}
                  </div>
                  <div>{selectedItem.siret}</div>
                  <div>
                    {selectedItem.streetNumber} {selectedItem.streetType}{" "}
                    {selectedItem.streetName}
                  </div>
                  <div>
                    {selectedItem.postalCode} {selectedItem.city}
                  </div>
                  <span
                    onClick={() => {
                      clearSelection()
                    }}
                    className={classNames.clearButton}
                  >
                    X
                  </span>
                </div>
              )
            ) : (
              <input
                {...getInputProps({
                  onFocus: openMenu,
                })}
                className="input"
                id="siret"
                name="siret"
                placeholder="Raison sociale ou SIRET"
                onFocus={handleInputFocus}
                required
              />
            )}
            {isListVisible && !selectedItem && (
              <ul
                {...getMenuProps({ isOpen })}
                className={classNames.menuList}
              >
                {(() => {
                  if (!isOpen) {
                    return null
                  }

                  // if (!inputValue) {
                  //   return <li>Je suis en création d'entreprise</li>
                  // }

                  return (
                    <Axios
                      url={baseEndpoint}
                      params={{ q: inputValue }}
                    >
                      {({ loading, error, data = [] }) => {
                        console.log("data", data)
                        if (loading) {
                          return <li disabled>Chargement...</li>
                        }

                        if (error) {
                          console.log("erreur! " + error)
                          return (
                            <li disabled>
                              Erreur lors de la communication avec le serveur.
                              <br /> Merci de réessayer plus tard.
                            </li>
                          )
                        }

                        data = [{ isNew: true }, ...data]
                        // if (!data || data.length == 0) {
                        //   return <li disabled>Pas d'entreprise trouvée.</li>
                        // }

                        return data.map((item, index) => {
                          const isSelected = selectedItem === item
                          const isActive = highlightedIndex === index
                          return (
                            <li
                              key={item.siret}
                              {...getItemProps({
                                item: item,
                                index,
                                isActive,
                                isSelected,
                              })}
                            >
                              {item?.isNew ? (
                                <div>
                                  <strong>
                                    Je suis en création d’entreprise, ou je ne
                                    trouve pas mon entreprise
                                  </strong>
                                </div>
                              ) : (
                                <>
                                  <div>
                                    <strong>{item.companyName}</strong>
                                  </div>
                                  <div>{item.siret}</div>
                                  <div>
                                    {item.streetNumber} {item.streetType}{" "}
                                    {item.streetName}
                                  </div>
                                  <div>
                                    {item.postalCode} {item.city}
                                  </div>
                                </>
                              )}
                            </li>
                          )
                        })
                      }}
                    </Axios>
                  )
                })()}
              </ul>
            )}
          </div>
        )}
      </Downshift>
    // </Suspense>
  )
}
